/* eslint-disable radix */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable global-require */

import el from '@finn-no/create-element';
import pulse from '@finn-no/pulse-sdk';
import SuggestionsDropdown from './suggestions-dropdown';

export default function search(form, apiUrl, finnBaseUrl, client, shadowRoot) {
    const savedSearchUrl = `${finnBaseUrl}/savedsearches`;
    const vertical = form.getAttribute('data-vertical');
    const deleteLastSearchesUrl = `${apiUrl}/delete/lastsearches?vertical=${vertical}`;
    const suggestUrl = `${apiUrl}/suggest`;
    const isDropdown = form.hasAttribute('data-is-dropdown');
    const where = form.getAttribute('data-where');
    const beta = form.getAttribute('data-beta');
    const searchKeys = form.getAttribute('data-search-keys') || '';
    const spinnerEle = form.querySelector('[data-spinner]');
    const inputEle = form.elements.q;
    const bapOpenFiltersOverlayEnabled = form.hasAttribute(
        'data-bap-open-filters-overlay-enabled',
    );
    const isNoTermQueryEnabled =
        form.getAttribute('data-unleash-isNoTermQueryEnabled') === 'true';

    let canceler; // XHR abort
    let dropdownEle;
    let lastTerm = '';
    let noTermModal = false;
    let suggestionsDropdown;
    let trackingData = null;

    function trackClickedItem(a) {
        try {
            const pickedIndex = JSON.parse(a.getAttribute('data-order'));

            if (trackingData === null || pickedIndex === null) {
                // should be logged to trackjs: Data or pickedIndex is not defined
                return;
            }

            const pickedItem = trackingData.search.items.find(
                (item) => item.order === pickedIndex,
            );

            if (pickedItem === null) {
                // should be logged to trackjs: could not find picked item
                return;
            }

            const updatedData = {
                ...trackingData,
                object: {
                    ...pickedItem,
                },
            };

            pulse.trackEvent(updatedData);
        } catch (e) {
            // should be logged to trackjs
        }
    }

    function escapeRegExp(s) {
        // https://github.com/benjamingr/RegExp.escape/blob/master/polyfill.js
        return String(s).replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function renderHighlightedTerm(text) {
        // Turn "Term Term1 " into /(^|\s)(Term1|Term)/, the terms being escaped.
        // `(^|\s)` is added to only highlight beginning of words.
        const pattern = `(^|\\s)(${lastTerm
            .trim()
            .split(/\s+/)
            // Sort by length (longest first) since the matching is eager, e.g.:
            //  Bad:  "t t1".match(/t|t1/gi) -> ["t", "t"]
            //  Good: "t t1".match(/t1|t/gi) -> ["t", "t1"]
            .sort((term1, term2) => term2.length - term1.length)
            .map(escapeRegExp)
            .join('|')})`;
        const termsRegExp = new RegExp(pattern, 'gi');
        let termsToHighlight = text.match(termsRegExp);
        if (!termsToHighlight) {
            return [text];
        }

        termsToHighlight = termsToHighlight.map((s) => s.trim()); // some matches might include whitespace

        return text
            .split(termsRegExp)
            .filter(Boolean)
            .reduce(
                (prev, curr) =>
                    prev.concat(
                        termsToHighlight.indexOf(curr) === -1
                            ? curr
                            : el('b', null, curr),
                    ),
                [],
            );
    }

    function renderTitle(titleText, secondaryTitle) {
        const text = titleText || '';
        const title = text + (secondaryTitle ? ` - ${secondaryTitle}` : '');
        return el(
            'span',
            { title, 'data-title': '' },
            renderHighlightedTerm(title),
        );
    }

    function renderInfoSingleLine(text) {
        return el(
            'span.fps__result__minor-text.fps--long-text',
            { title: text },
            renderHighlightedTerm(text),
        );
    }

    function renderInfo2(text) {
        return el('span.fps__result__minor-text', null, text);
    }

    function renderResultCompanyProfile(result) {
        return el(
            'li.fps__result__item.selectable__list__item',
            null,
            el(
                'a.fps__result__link',
                {
                    href: result.url,
                    'data-order': result.order,
                },
                el('img.fps__result__image', {
                    src: result.imgUrl.replace('640w', '240w'),
                    style: 'max-height: 100%; padding: 5px;',
                }),
                el(
                    'div.fps__result__text',
                    null,
                    renderTitle(result.title),
                    result.info1 ? renderInfoSingleLine(result.info1) : null,
                    result.info2 ? renderInfo2(result.info2) : null,
                ),
            ),
        );
    }

    function renderGroupCompanyProfile(group, resultType, groupingHeader) {
        return el(
            'div.fps-search-results',
            { 'data-group-type': resultType },
            el('h2.u-t5.u-stone.fps-medium-weight', null, groupingHeader),
            el(
                'ol.fps__result__items',
                { role: 'presentation', style: 'width: 100%' },
                group.map(renderResultCompanyProfile),
            ),
        );
    }

    function renderResultSearchFinn(result, isSingleResult) {
        const url = new URL(result.url);

        const hrefAndClass = isSingleResult
            ? 'a.fps-search-link.fps-search-simple-cta.u-caption.link'
            : 'a.fps-search-link.fps-search-cta.u-caption.link';

        return el(
            'li.selectable__list__item',
            null,
            el(
                hrefAndClass,
                {
                    href: url.href,
                    'data-order': result.order,
                    'data-choose-me': result.chooseMe,
                },
                el(
                    'svg:svg.fps__result__image',
                    { width: '34', height: '34', viewBox: '0 0 34 34' },
                    el('svg:path', {
                        d:
                            'M29.555 29.586l.03-.03-6.007-6.008.596-.703a11.393 11.393 0 0 0 2.715-7.4C26.889 9.123 ' +
                            '21.765 4 15.444 4 9.124 4 4 9.124 4 15.444 4 21.765 9.124 26.89 15.444 26.89c2.75 ' +
                            '0 5.348-.972 7.401-2.715l.703-.596 6.007 6.008z',
                        fill: 'none',
                        stroke: '#474445',
                        'stroke-width': '2',
                    }),
                ),
                ' ',
                el(
                    'div.fps__result__text',
                    { 'data-title': '' },
                    'Finn flere resultater for ',
                    el('b', null, result.title.substring(26)),
                ),
            ),
        );
    }

    function renderGroupSearchFinn(group, resultType, isSingleResult) {
        const divClass = isSingleResult ? 'div' : 'div.u-mt16.u-pt8';
        return el(
            divClass,
            { 'data-group-type': resultType },
            el(
                'ol.fps-search-items',
                { role: 'presentation' },
                group.map((gr) => renderResultSearchFinn(gr, isSingleResult)),
            ),
        );
    }

    function renderResultAd(result) {
        return el(
            'li.fps__result__item.selectable__list__item',
            null,
            el(
                'a.fps__result__link',
                {
                    href: result.url,
                    'data-automation-id': 'global_search_suggestion',
                    'data-order': result.order,
                    'data-choose-me': result.chooseMe,
                },
                el('img.fps__result__image', {
                    src: result.imgUrl.replace(
                        /\/mmo\/|\/dynamic\/default\//,
                        '/dynamic/300x225c/',
                    ),
                    width: '100',
                    height: '75',
                }),
                el(
                    'div.fps__result__text',
                    null,
                    renderTitle(result.title),
                    renderInfoSingleLine(result.info1),
                ),
            ),
        );
    }

    function renderSingleLastSearch(result) {
        return el(
            'a.fps-last-search.selectable__list__item',
            {
                href: result.url,
                'data-automation-id': 'global_search_suggestion',
                'data-order': result.order,
                'data-choose-me': result.chooseMe,
            },
            el(
                'div.fps-last-search-title.u-caption',
                null,
                renderTitle(result.title),
                renderInfoSingleLine(result.info1),
            ),
            result.secondaryTitle
                ? el(
                      'div.fps-last-search-category.u-caption',
                      null,
                      result.secondaryTitle,
                  )
                : '',
        );
    }

    function renderSingleSavedSearch(result) {
        const image = result.imageId === undefined ? 'finn' : result.imageId;
        return el(
            'a.fps-saved-search.selectable__list__item',
            {
                href: result.url,
                'data-automation-id': 'global_search_suggestion',
                'data-order': result.order,
                'data-choose-me': result.chooseMe,
            },
            el('img.fps-saved-search-image', {
                src: `https://static.finncdn.no/_c/static/search-assets/newfrontier/${image}.png`,
                width: '40',
                height: '40',
            }),
            el(
                'div.fps-saved-search-title.u-caption',
                null,
                renderTitle(result.title),
                renderInfoSingleLine(result.info1),
            ),
            result.secondaryTitle
                ? el(
                      'div.fps-saved-search-category',
                      null,
                      result.secondaryTitle,
                  )
                : '',
        );
    }

    function renderPopularButtons(result) {
        return el(
            'div.selectable__list__item',
            null,
            el(
                'a.fps-popular-button.u-caption',
                {
                    href: result.url,
                },
                result.title,
            ),
        );
    }

    function renderGroupPopular(group, resultType, groupingHeader) {
        return el(
            'div.u-pt16.u-mt8',
            { 'data-group-type': resultType },
            el(
                'h2.fps-category-title.u-t4.u-mb8.u-pb4.fps-medium-weight',
                null,
                groupingHeader,
            ),
            el(
                'div.fps-popular-button-grid',
                { role: 'presentation' },
                group.map(renderPopularButtons),
            ),
        );
    }

    function removeLastSearches(eleToBeRemoved) {
        window.fetch(deleteLastSearchesUrl, {
            method: 'DELETE',
            credentials: 'include',
        });
        eleToBeRemoved.parentElement.removeChild(eleToBeRemoved);
    }

    function renderLastSearchesGroup(group) {
        return el(
            'div.fps-last-search-grid',
            { role: 'presentation' },
            group.map(renderSingleLastSearch),
        );
    }

    function renderGroupLastSearches(group, resultType, groupingHeader) {
        const buttonEle = el(
            'div.u-mt8',
            null,
            el(
                'button.button--link.fps-empty-list-cta',
                {
                    type: 'button',
                    tabindex: 0,
                },
                el(
                    'svg:svg',
                    { width: '16', height: '16', viewBox: '0 0 16 16' },
                    el('svg:path', {
                        d: 'M6 1.75a.25.25 0 00-.25.25v.75h4.5V2a.25.25 0 00-.25-.25H6zm5.75 1V2A1.75 1.75 0 0010 .25H6A1.75 1.75 0 004.25 2v.75H2.51a.75.75 0 00-.017 0H1a.75.75 0 000 1.5h.812l.44 5.065.461 5.293a1.25 1.25 0 001.245 1.142h8.084a1.25 1.25 0 001.245-1.142l.9-10.358H15a.75.75 0 000-1.5h-3.25zM11 4.25H3.318l.43 4.935.44 5.065h7.624l.87-10H11zm-1.5 2a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0V7a.75.75 0 01.75-.75zM7.25 7a.75.75 0 00-1.5 0v4.5a.75.75 0 001.5 0V7z',
                        fill: 'currentColor',
                        'fill-rule': 'evenodd',
                        'clip-rule': 'evenodd',
                    }),
                ),

                el(
                    'div.u-t5.u-ml8.u-mt2',
                    {
                        id: 'remove-last-searches-button', // needed to identify this button in the dropdown
                    },
                    'Fjern all søkehistorikk',
                ),
            ),
        );
        const lastSearchesEle = el(
            'div',
            { 'data-group-type': resultType },
            el(
                'h2.fps-category-title.u-t4.u-mb8.u-pb4.fps-medium-weight',
                null,
                groupingHeader,
            ),
            renderLastSearchesGroup(group),
            buttonEle,
        );
        buttonEle.addEventListener('click', (evt) => {
            evt.preventDefault();
            removeLastSearches(lastSearchesEle);
        });

        return lastSearchesEle;
    }

    function renderGroupSavedSearches(group, resultType, groupingHeader) {
        return el(
            'div.u-pt16.u-mt8',
            { 'data-group-type': resultType },
            el(
                'h2.fps-category-title.u-t4.u-mb8.fps-medium-weight',
                null,
                groupingHeader,
            ),
            el(
                'div.fps-saved-search-grid',
                { role: 'presentation' },
                group.map(renderSingleSavedSearch),
            ),
            el(
                'div.u-mt4.selectable__list__item',
                null,
                el(
                    'a.u-t5',
                    {
                        href: savedSearchUrl, // todo ADOUT-17510 should probably track this click
                    },
                    'Vis alle lagrede søk',
                ),
            ),
        );
    }

    function formatNumber(result) {
        if (result.hits) {
            return result.hits.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        }
        return null;
    }

    function getAriaTitle(result) {
        const title = [];
        if (result.title) {
            title.push(result.title);
            if (result.secondaryTitle) {
                title.push('–', result.secondaryTitle);
            }
        } else if (result.secondaryTitle) {
            title.push(result.secondaryTitle);
        }
        return [
            result.groupingHeader,
            title.join(' '),
            result.info1,
            result.info2,
        ]
            .filter((v) => v != null)
            .join(', ');
    }

    function renderDefaultResult(result) {
        const ariaTitle = getAriaTitle(result);
        return el(
            'li.fps-search-item.selectable__list__item',
            { 'aria-label': ariaTitle },
            el(
                'a.link.link--dark.fps-search-link',
                {
                    href: result.url,
                    'data-automation-id': 'global_search_suggestion',
                    'data-order': result.order,
                    'aria-label': ariaTitle,
                },
                el(
                    'div.fps__result__text',
                    null,
                    renderTitle(result.title, result.secondaryTitle),
                    result.info1 ? renderInfoSingleLine(result.info1) : null,
                    ' ',
                    // eslint-disable-next-line no-nested-ternary
                    result.info2
                        ? renderInfo2(result.info2)
                        : result.hits
                        ? `(${formatNumber(result)} treff)`
                        : null,
                ),
            ),
        );
    }

    // renders search results

    function renderResultCommand(result) {
        return el(
            'li.fps__result__item.selectable__list__item',
            null,
            el(
                'div.fps__result__text',
                null,
                renderTitle(result.title),
                renderInfoSingleLine(result.info1),
            ),
        );
    }

    function renderResult(result) {
        switch (result.resultType) {
            case 'AD':
                return renderResultAd(result);

            case 'COMMAND':
                return renderResultCommand(result);

            default:
                return renderDefaultResult(result);
        }
    }

    function renderGroup(group, resultType, groupingHeader) {
        return el(
            'div.fps-search-results',
            { 'data-group-type': resultType },
            el('h2.u-t5.u-stone.fps-medium-weight', null, groupingHeader),
            // role=presentation here is because of a VoiceOver bug which doesn't read items unless we do this
            el(
                'ol.fps__result__items',
                { role: 'presentation' },
                group.map(renderResult),
            ),
        );
    }

    function renderGroupData(group, resultSetSize) {
        const { groupingHeader, results } = group;
        const { resultType } = group.results[0];

        if (resultType === 'SEARCH_FINN') {
            return renderGroupSearchFinn(
                results,
                resultType,
                resultSetSize === 1,
            );
        }

        if (where === 'BROWSE' && resultType === 'COMPANYPROFILE') {
            return renderGroupCompanyProfile(
                results,
                resultType,
                groupingHeader,
            );
        }

        return renderGroup(results, resultType, groupingHeader);
    }

    function renderNoTermGroupData(groups) {
        if (where === 'FRONTPAGE' || where === 'BROWSE') {
            const lastSearches = groups
                .filter(
                    (group) => group.results[0].resultType === 'LASTSEARCHES',
                )
                .map((lastSearchesGroup) =>
                    renderGroupLastSearches(
                        lastSearchesGroup.results,
                        'LASTSEARCHES',
                        lastSearchesGroup.groupingHeader,
                    ),
                );
            const savedSearches = groups
                .filter(
                    (group) => group.results[0].resultType === 'SAVEDSEARCH',
                )
                .map((savedSearchesGroups) =>
                    renderGroupSavedSearches(
                        savedSearchesGroups.results,
                        'SAVEDSEARCH',
                        savedSearchesGroups.groupingHeader,
                    ),
                );
            const popular = groups
                .filter((group) => group.results[0].resultType === 'POPULAR')
                .map((popularGroup) =>
                    renderGroupPopular(
                        popularGroup.results,
                        'POPULAR',
                        popularGroup.groupingHeader,
                    ),
                );

            return lastSearches.concat(savedSearches).concat(popular);
        }
        return [el('div.u-mv16')];
    }

    function setStatus(text) {
        if (suggestionsDropdown.setStatus) {
            suggestionsDropdown.setStatus(text);
        }
    }

    function render(responseItems, onsuccess) {
        const groups = Object.values(responseItems.results).filter(
            (itemValue) => itemValue !== null,
        );
        if (noTermModal) {
            dropdownEle = el('div', {}, renderNoTermGroupData(groups));
        } else {
            dropdownEle = el(
                'div',
                {},
                groups.map((group) => renderGroupData(group, groups.length)),
            );
        }
        dropdownEle.addEventListener('touchmove', () => {
            inputEle.blur();
        });
        onsuccess(dropdownEle);
        if (groups.length !== 0) {
            setStatus(
                `${groups
                    .map((group) => group.results.length)
                    .reduce((a, b) => a + b, 0)} forslag`,
            );
        }
    }

    function getRelocationUrl(a, inputText) {
        const replacedUrl = a.href.replace('REPLACEME', inputText);
        const url = new URL(replacedUrl);

        if (bapOpenFiltersOverlayEnabled) {
            url.searchParams.set('filters', '');
        }
        return url;
    }

    function trackAndRelocate(a, inputText) {
        trackClickedItem(a);
        const url = getRelocationUrl(a, inputText);
        window.location = url.href;
    }

    function findLink(selectedEle) {
        if (selectedEle && selectedEle.href) {
            return selectedEle;
        }
        return selectedEle && selectedEle.querySelector('a');
    }

    function getRenderOptions() {
        return {
            updateValue: false,
            hideOnDeactivation: isDropdown,
            selectedClass: 'fps__result__selected',
            dropdownClass: where === 'LANDINGPAGE' ? '' : 'fps__container',
            statusClass: 'u-screen-reader-only fps__status',
            insertionElement: form.querySelector('[data-dropdown-insertion]'),
            timeout: 0,
            onsubmit(inputText, selectedEle) {
                const chooseMeEle =
                    dropdownEle.querySelector('[data-choose-me]');

                if (!selectedEle && chooseMeEle) {
                    trackAndRelocate(chooseMeEle, inputText);
                    return;
                }

                const a = findLink(selectedEle);
                if (a && a.href) {
                    trackAndRelocate(a, inputText);
                    return;
                }

                if (!inputText || inputText.length < 1) {
                    return;
                }

                form.submit();
            },
            onclose() {
                if (render.cancel) {
                    render.cancel();
                }
            },
            contentGetter(ele) {
                return (ele.querySelector('[data-title]') || ele).textContent;
            },
        };
    }

    function hideSpinner() {
        if (spinnerEle) {
            spinnerEle.remove();
        }
    }

    function reset() {
        hideSpinner();
    }

    function createFetchUrl(base, term) {
        const url = new URL(base);

        url.searchParams.set('dropdown', true);
        url.searchParams.set('searchKey', searchKeys);
        url.searchParams.set('client', client);
        url.searchParams.set('beta', beta);
        url.searchParams.set('where', where);
        url.searchParams.set('term', term);

        return url.href;
    }

    function abort() {
        if (canceler) {
            canceler();
            reset();
            canceler = null;
        }
    }

    function handleEmptyResult() {
        suggestionsDropdown.hide();
    }

    function fetch(term, onsuccess) {
        const lastNoTermModal = noTermModal;

        noTermModal = term.length < 2;

        if (
            (!isNoTermQueryEnabled && noTermModal) ||
            (noTermModal && lastNoTermModal)
        ) {
            return;
        }

        lastTerm = term;

        abort();

        const xhr = new XMLHttpRequest();

        xhr.open('GET', createFetchUrl(suggestUrl, term));
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.setRequestHeader(
            'Content-Type',
            'application/x-www-form-urlencoded',
        );
        xhr.withCredentials = true;
        xhr.onreadystatechange = () => {
            if (xhr.readyState === XMLHttpRequest.DONE && xhr.responseText) {
                const response = JSON.parse(xhr.responseText);

                if (response.results && response.results.length > 0) {
                    render(response, onsuccess);
                    if (response.metaData) {
                        trackingData = response.metaData.tracking;
                    }
                } else {
                    handleEmptyResult();
                }
            }
        };

        xhr.send();

        canceler = () => xhr.abort();
    }

    const options = getRenderOptions();

    suggestionsDropdown = new SuggestionsDropdown(
        inputEle,
        fetch,
        abort,
        options,
        shadowRoot,
    );
}
